"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatchAllEvent = exports.TYPES = exports.EVENTS = exports.COMMANDS = exports.Extension = void 0;
class Extension {
    static CatchAllEvent;
    static BasicUser;
    static BasicNetwork;
    static CleanExtMessage;
    static CommResponse;
    static CleanResponse;
    static PostMessage;
    static PortMessage;
    static Payload;
    static AppStatus;
    static AllExtMessage;
    static ExtMessage;
    static RequestMessage;
    static ResponseMessage;
    static Targets;
    static Events;
    static Commands;
    static Types;
}
exports.Extension = Extension;
(function (Extension) {
    let TYPES;
    (function (TYPES) {
        TYPES["INIT"] = "init";
        TYPES["REFRESH"] = "refresh";
        TYPES["DISCONNECT"] = "disconnect";
        TYPES["PING"] = "ping";
        TYPES["REQUEST"] = "request";
        TYPES["RESPONSE"] = "response";
        TYPES["UPDATE"] = "update";
        TYPES["EVENT"] = "event";
    })(TYPES = Extension.TYPES || (Extension.TYPES = {}));
    let COMMANDS;
    (function (COMMANDS) {
        COMMANDS["VERSION"] = "version";
        COMMANDS["IS_CONNECTED"] = "isConnected";
        COMMANDS["IS_LOCKED"] = "isLocked";
        COMMANDS["OPEN"] = "open";
        COMMANDS["SIGN"] = "sign";
        COMMANDS["SIGNANDSUBMIT"] = "sign-and-submit";
        COMMANDS["BULKSUBMIT"] = "bulk-submit";
        COMMANDS["BULKSIGN"] = "bulk-sign";
        COMMANDS["BULK"] = "bulk";
        COMMANDS["SUBMIT"] = "submit";
        COMMANDS["MANAGER"] = "manager";
        COMMANDS["ADDRESS"] = "address";
        COMMANDS["NETWORK"] = "network";
        COMMANDS["USER"] = "user";
        COMMANDS["VERIFY"] = "verify";
        COMMANDS["SENDER"] = "sender";
        COMMANDS["CHANGENODE"] = "change-node";
        COMMANDS["CHANGEUSER"] = "change-user";
        COMMANDS["DECRYPT"] = "decrypt";
        COMMANDS["ENCRYPT"] = "encrypt";
    })(COMMANDS = Extension.COMMANDS || (Extension.COMMANDS = {}));
    let EVENTS;
    (function (EVENTS) {
        EVENTS["ACCOUNTS_CHANGED"] = "accountsChanged";
        EVENTS["CHAIN_CHANGED"] = "chainChanged";
        EVENTS["CONNECT"] = "connect";
        EVENTS["DISCONNECT"] = "disconnect";
        EVENTS["MESSAGE"] = "message";
        EVENTS["POPUP_MODE"] = "popup-mode";
        EVENTS["STATE_UPDATE"] = "state-update";
        EVENTS["NETWORK_CHANGE"] = "network-change";
        EVENTS["USER_CHANGE"] = "user-change";
        EVENTS["OPEN"] = "open";
        EVENTS["CLOSE"] = "close";
        EVENTS["PING"] = "ping";
        EVENTS["SIGNIN"] = "signin";
        EVENTS["SIGNOUT"] = "signout";
        EVENTS["RESPONSE"] = "response";
        EVENTS["ALL"] = "all";
    })(EVENTS = Extension.EVENTS || (Extension.EVENTS = {}));
    let TARGETS;
    (function (TARGETS) {
        TARGETS["CONTENT"] = "content";
        TARGETS["BG"] = "bg";
        TARGETS["POP"] = "pop";
    })(TARGETS = Extension.TARGETS || (Extension.TARGETS = {}));
})(Extension || (exports.Extension = Extension = {}));
exports.COMMANDS = Extension.COMMANDS;
exports.EVENTS = Extension.EVENTS;
exports.TYPES = Extension.TYPES;
exports.CatchAllEvent = Extension.CatchAllEvent;
//# sourceMappingURL=index.js.map